/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
// ===== IMPORTACIONES =====
import $ from "jquery";

// Hacer jQuery disponible globalmente dentro del módulo
window.jQuery = $;
window.$ = $;
import "select2";

async function getCategories(categoryType) {
    let baseUrl = window.location.origin;
    if (window.location.hostname.includes("localhost")) {
        baseUrl += "/local";
    }
    const url = baseUrl + "/.rest/delivery/getCategories?categoryType=" + categoryType + "&limit=10000";

    const response = await fetch(url);
    if (!response.ok) throw new Error("Network error");

    const data = await response.json();
    const formattedData = data.results.reduce((acc, item) => {
        acc[item.name] = {
            "en-US": item.name,
            "zh-CN": item[categoryType + "translation_chinese"],
            "es-ES": item[categoryType + "translation_spanish"]
        };
        return acc;
    }, {});

    return formattedData;
}

function init() {
    // ===== VARIABLES GLOBALES DEL MÓDULO =====
    let translations = {};
    let localization = "en-US";
    let jobAreasList = {};
    let locationsList = {};
    let statesList = {};
    let currentPage = 1;
    const itemsPerPage = 20;
    let jobsUrl = "";

    const ignoredParams = ["search", "team", "country", "region", "location", "position", "type", "profile"];
    const queryParams = new URLSearchParams(window.queryString);
    const seoParams = new URLSearchParams();
    for (const [key, value] of queryParams.entries()) {
        if (!ignoredParams.includes(key)) {
            seoParams.append(key, value);
        }
    }
    const seoQueryString = seoParams.toString();

    // ===== FUNCIONES DE UTILIDAD =====
    function getParams() {
        const urlParams = new URLSearchParams(window.location.search);
        let params = {};
        urlParams.forEach((value, key) => {
            if (params[key]) {
                if (Array.isArray(params[key])) {
                    params[key].push(value);
                } else {
                    params[key] = [params[key], value];
                }
            } else {
                params[key] = [value];
            }
        });
        return params;
    }

    // ===== FUNCIONES DE INICIALIZACIÓN =====
    function initializeTranslations() {
        // Detectar localización desde la URL
        const uri = window.location.pathname;
        if (uri.match(/.*\/cn($|\/*|\.html|.*)/)) {
            localization = "zh-CN";
        } else if (uri.match(/.*\/es($|\/*|\.html|.*)/)) {
            localization = "es-ES";
        } else {
            localization = "en-US";
        }

        // Definir traducciones
        translations = {
            "en-US": {
                selectOption: "Select an option",
                more: "more",
                load_more: "Load More",
                similar_job_title: "Similar Jobs",
                filter: "Filters",
                clear_filter: "Clear Filters",
                sbyT: "Search by Title or Keyword",
                sbyCA: "Search Jobs by Career Area",
                country: "Search Jobs by Country",
                region: "Region/State/Province",
                loc: "Location",
                position: "Job Type",
                job_type: "Job Type",
                view_bio: "VIEW JOB",
                category: "Category",
                posted: "Posted",
                type: "Time Type",
                apply_filters: "Apply Filters",
                results: "Results",
                back_to_search: "Back to Search",
                "Full time": "Full time",
                "Part time": "Part time",
                "Contingent Worker": "Contingent Worker",
                "Permanent Employee": "Permanent Employee",
                "Temporary Employee": "Temporary Employee",
                "Inventory Control": "Inventory Control",
                no_results: "No results found",
                searching: "Searching"
            },
            "zh-CN": {
                selectOption: "选择一个选项",
                more: "更多",
                load_more: "加载更多",
                similar_job_title: "类似职位",
                filter: "筛选",
                clear_filter: "清除筛选",
                sbyT: "按标题或关键词搜索工作",
                sbyCA: "按职业领域搜索职位",
                country: "按国家搜索职位",
                region: "地区/州/省",
                loc: "地点",
                position: "职位种类",
                job_type: "工作类型",
                view_bio: "查看工作",
                category: "类别",
                posted: "已发布",
                type: "类型",
                apply_filters: "应用筛选器",
                results: "结果",
                back_to_search: "返回搜索",
                "Full time": "全职工作",
                "Part time": "兼职工作",
                "Contingent Worker": "临时工",
                "Permanent Employee": "全职工作",
                "Temporary Employee": "兼职工作",
                "Inventory Control": "库存管控",
                no_results: "没有找到结果",
                searching: "搜寻中"
            },
            "es-ES": {
                selectOption: "Selecciona una opción",
                more: "más",
                load_more: "Cargar más",
                similar_job_title: "Empleos Similares",
                filter: "Filtrar",
                clear_filter: "Limpiar Filtros",
                sbyT: "Buscar trabajos por título o palabra clave",
                sbyCA: "Buscar trabajos por área de carrera",
                country: "Buscar trabajos por País",
                region: "Región/Estado/Provincia",
                loc: "Ubicación",
                position: "Posición",
                job_type: "Tipo de Empleo",
                view_bio: "VER EMPLEO",
                category: "Categoría",
                posted: "Publicado",
                type: "Tipo",
                apply_filters: "APLICAR FILTROS",
                results: "Resultados",
                back_to_search: "Volver a la búsqueda",
                "Full time": "Tiempo completo",
                "Part time": "Medio tiempo",
                "Contingent Worker": "Trabajador Eventual",
                "Permanent Employee": "Empleado Permanente",
                "Temporary Employee": "Empleado Temporal",
                "Inventory Control": "Control de Inventarios",
                no_results: "No se encontraron resultados",
                searching: "Buscando"
            }
        };

        // Hacer disponibles globalmente para compatibilidad
        window.translations = translations;
        window.localization = localization;
    }

    function setTitlesByLocalization() {
        const elements = {
            ".title-filter": translations[localization].filter,
            'label[for="search"]': translations[localization].sbyT + ":",
            'label[for="team"]': translations[localization].sbyCA + ":",
            'label[for="country"]': translations[localization].country + ":",
            'label[for="region"]': translations[localization].region + ":",
            'label[for="location"]': translations[localization].loc + ":",
            'label[for="position"]': translations[localization].position + ":",
            'label[for="type"]': translations[localization].type + ":",
            "#apply_filters": translations[localization].apply_filters,
            "#clear-filters": translations[localization].clear_filter
        };

        Object.entries(elements).forEach(([selector, text]) => {
            const element = document.querySelector(selector);
            if (element) {
                element.innerHTML = text;
            }
        });
    }

    // ===== FUNCIONES DE SELECT2 =====
    function initializeMultiSelects() {
        // Verificar que jQuery y Select2 estén disponibles
        if (typeof $ === "undefined") {
            setTimeout(initializeMultiSelects, 100);
            return;
        }

        if (typeof $.fn.select2 === "undefined") {
            setTimeout(initializeMultiSelects, 100);
            return;
        }

        // Destruir instancias previas
        $(".select2-multiple").each(function() {
            if ($(this).hasClass("select2-hidden-accessible")) {
                $(this).select2("destroy");
            }
        });

        const select2Config = {
            placeholder: translations[localization].selectOption,
            allowClear: true,
            closeOnSelect: true,
            width: "100%",
            dropdownParent: $("body"),
            language: {
                noResults: function() {
                    return translations[localization].no_results;
                },
                searching: function() {
                    return translations[localization].searching + "...";
                }
            }
        };

        // Inicializar cada select individualmente
        const selects = [
            { id: "#team", placeholder: translations[localization].sbyCA },
            { id: "#country", placeholder: translations[localization].country },
            { id: "#region", placeholder: translations[localization].region },
            { id: "#location", placeholder: translations[localization].loc },
            { id: "#position", placeholder: translations[localization].position },
            { id: "#type", placeholder: translations[localization].type }
        ];

        selects.forEach(({ id }) => {
            const element = $(id);
            if (element.length > 0) {
                try {
                    // Verificar que el elemento no tenga Select2 ya inicializado
                    if (!element.hasClass("select2-hidden-accessible")) {
                        element.select2({
                            ...select2Config,
                            placeholder: placeholder
                        });
                    }
                } catch (error) {
                    // Error inicializando select
                }
            }
        });

        // Verificar que Select2 se inicializó correctamente
        setTimeout(() => {
            $(".select2-multiple").each(function() {
                if (!$(this).hasClass("select2-hidden-accessible")) {
                    try {
                        $(this).select2(select2Config);
                    } catch (e) {
                        //
                    }
                }
            });
        }, 500);

        document.querySelector("#clear-filters").addEventListener("click", function() {
            console.log("Limpiando filtros");

            // 1. Limpiar campos del formulario
            const searchInput = document.getElementById("search");
            if (searchInput) searchInput.value = "";

            const selectIds = ["team", "country", "region", "location", "position", "type"];
            selectIds.forEach(id => {
                const select = document.getElementById(id);
                if (select) {
                    if (select.multiple) {
                        Array.from(select.options).forEach(option => (option.selected = false));
                    } else {
                        select.value = "";
                    }
                }
            });

            // 2. Construir nueva URL
            const query = seoQueryString ? `?${seoQueryString}` : "";
            window.location.href = window.location.pathname + query;
        });

        // Función mejorada para mostrar todas las opciones
        function showAllOptions(selectElement) {
            const $select = $(selectElement);

            // Si hay opciones originales guardadas, restaurarlas
            if ($select.data("allOptions")) {
                const allOptions = $select.data("allOptions").clone();
                $select.empty();
                $select.append(allOptions);
                $select.val(null).trigger("change");
                $select.select2();
            }
        }

        function filterOptions(selectElement, attribute, values) {
            const $select = $(selectElement);

            // Guardar las opciones originales (una sola vez)
            if (!$select.data("allOptions")) {
                $select.data("allOptions", $select.find("option").clone());
            }

            // Clonar las opciones originales para empezar de cero
            const allOptions = $select.data("allOptions").clone();
            $select.empty();

            // Filtrar y agregar solo las opciones válidas
            allOptions.each(function() {
                const $option = $(this);
                const attrValues = ($option.data(attribute) || "").toString().split(",");
                const shouldInclude = $option.val() === "" || values.some(val => attrValues.includes(val));
                if (shouldInclude) {
                    $select.append($option);
                }
            });

            // Volver a inicializar Select2 con las opciones filtradas
            $select.val(null).trigger("change");
            $select.select2();
        }

        const stateFilter = document.getElementById("region");
        const cityFilter = document.getElementById("location");

        $("#country").on("select2:select select2:unselect change", function() {
            const selectedCountries = $(this).val();

            if (selectedCountries && selectedCountries.length > 0) {
                // Si hay países seleccionados, filtrar
                filterOptions(stateFilter, "country", selectedCountries);
                filterOptions(cityFilter, "country", selectedCountries);
            } else {
                // Si no hay países seleccionados, mostrar todas las opciones
                showAllOptions(stateFilter);
                showAllOptions(cityFilter);
            }
        });

        $("#region").on("select2:select select2:unselect change", function(e) {
            e.stopPropagation();
            const selectedStates = $(this).val();
            const selectedCountries = $("#country").val();
            if (selectedStates.length > 0) {
                $(this)
                    .next(".select2")
                    .find(".select2-selection.select2-selection--multiple")
                    .addClass("select2-selection--clearable");
            } else {
                $(this)
                    .next(".select2")
                    .find(".select2-selection.select2-selection--multiple")
                    .removeClass("select2-selection--clearable");
            }
            if (selectedStates && selectedStates.length > 0) {
                // Si hay estados seleccionados, filtrar cities por estado
                filterOptions(cityFilter, "state", selectedStates);
            } else if (selectedCountries && selectedCountries.length > 0) {
                // Si no hay estados pero sí países, filtrar cities por país
                filterOptions(cityFilter, "country", selectedCountries);
            } else {
                // Si no hay nada seleccionado, mostrar todas las cities
                showAllOptions(cityFilter);
            }
        });

        $("#location").on("select2:select select2:unselect change", function(e) {
            e.stopPropagation();
            const selectedLocation = $(this).val();
            if (selectedLocation.length > 0) {
                $(this)
                    .next(".select2")
                    .find(".select2-selection.select2-selection--multiple")
                    .addClass("select2-selection--clearable");
            } else {
                $(this)
                    .next(".select2")
                    .find(".select2-selection.select2-selection--multiple")
                    .removeClass("select2-selection--clearable");
            }
        });
    }

    function populateAreaSelect(data) {
        const select = document.getElementById("team");
        if (!select) return;

        select.innerHTML = '<option value=""></option>';

        Object.keys(data)
            .sort((a, b) => {
                const textA = (data[a] && data[a][localization]) || a;
                const textB = (data[b] && data[b][localization]) || b;
                return textA.localeCompare(textB);
            })
            .forEach(key => {
                const textTranslation = data[key] && data[key][localization];
                if (textTranslation) {
                    const option = document.createElement("option");
                    option.value = (data[key] && data[key]["en-US"]) || "";
                    option.textContent = textTranslation;
                    select.appendChild(option);
                }
            });
    }

    function populateSelect(id, dataSet) {
        const select = document.getElementById(id);
        if (!select) return;

        select.innerHTML = '<option value=""></option>';

        dataSet
            .sort((a, b) => a.localeCompare(b))
            .forEach(value => {
                const textTranslation = translations[localization][value];
                if (textTranslation) {
                    const option = document.createElement("option");
                    option.value = value;
                    option.textContent = textTranslation;
                    select.appendChild(option);
                }
            });
    }

    // ===== FUNCIÓN PARA POBLAR FILTROS DE UBICACIÓN =====
    function populateLocationFilters(countrySet, stateSet, citySet) {
        // Poblar países
        const countryFilter = document.getElementById("country");
        if (countryFilter) {
            countryFilter.innerHTML = '<option value=""></option>';
            Array.from(countrySet)
                .sort()
                .forEach(country => {
                    const option = document.createElement("option");
                    option.value = country;
                    option.textContent = country;
                    countryFilter.appendChild(option);
                });
        }

        // Poblar estados/regiones
        const stateFilter = document.getElementById("region");
        if (stateFilter) {
            stateFilter.innerHTML = '<option value=""></option>';
            const stateCountryMap = new Map();

            Array.from(stateSet)
                .sort(([stateA], [stateB]) => stateA.localeCompare(stateB))
                .forEach(([state, country]) => {
                    if (stateCountryMap.has(state)) {
                        let countries = stateCountryMap.get(state);
                        if (!countries.includes(country)) {
                            countries.push(country);
                        }
                    } else {
                        stateCountryMap.set(state, [country]);
                    }
                });

            stateCountryMap.forEach((countries, state) => {
                const option = document.createElement("option");
                option.value = state;
                option.setAttribute("data-country", countries.join(","));
                option.textContent = state;
                stateFilter.appendChild(option);
            });
        }

        // Poblar ubicaciones
        const cityFilter = document.getElementById("location");
        if (cityFilter) {
            cityFilter.innerHTML = '<option value=""></option>';
            Array.from(citySet)
                .sort(([locationA], [locationB]) => locationA.localeCompare(locationB))
                .forEach(([location, state, country]) => {
                    const option = document.createElement("option");
                    option.value = location;
                    option.setAttribute("data-state", state);
                    option.setAttribute("data-country", country);
                    option.textContent = location;
                    cityFilter.appendChild(option);
                });
        }
    }

    // ===== FUNCIONES DE FILTRADO =====
    async function filterJobList(jobList) {
        const countrySet = new Set();
        const stateSet = new Set();
        const citySet = new Set();
        const positionTypeSet = new Set();
        const jobTypeSet = new Set();

        const jobListFiltered = [];
        const params = getParams();
        const noParams = Object.keys(params).length === 0;

        const { search, team, country, region, location, position, type, profile } = params;

        // Helper functions
        const matchesArrayFilter = (value, filterArray) => {
            return filterArray && filterArray.some(filter => value.toLowerCase() === filter.toLowerCase());
        };

        const searchMultipleTerms = (job, searchTerms) => {
            return searchTerms.some(term => {
                const termLower = term.trim().toLowerCase();
                if (!termLower) return false;

                const jobTitleLower = (job.Job_Posting_Title || "").toLowerCase();
                const jobReqId = (job.Job_Requisition_ID || "").toLowerCase();
                const jobReqIdWithCategory = (job.Job_Requisition_ID || "") + "-" + (job.Job_Category || "");
                const jobReqIdWithCategoryLower = jobReqIdWithCategory.toLowerCase();

                if (jobTitleLower.includes(termLower) || jobReqId.includes(termLower) || jobReqIdWithCategoryLower.includes(termLower)) {
                    return true;
                }

                return searchInJobFields(job, term);
            });
        };

        function parseSearchQuery(query) {
            const terms = [];
            const excludeTerms = [];
            const regex = /"([^"]+)"|(\S+)/g; // captura frases en comillas o palabras sueltas

            let match;
            while ((match = regex.exec(query)) !== null) {
                if (match[1]) {
                    // frase exacta (sin comillas)
                    terms.push({ text: match[1], exact: true });
                } else if (match[2].startsWith("-")) {
                    // palabra excluida
                    excludeTerms.push(match[2].substring(1).toLowerCase());
                } else {
                    // palabra normal
                    terms.push({ text: match[2], exact: false });
                }
            }

            return { terms, excludeTerms };
        }

        function matchesAdvancedSearch(text, terms, excludeTerms) {
            if (!text) return false;

            const textLower = text.toLowerCase();

            // Chequear exclusiones
            for (const ex of excludeTerms) {
                if (textLower.includes(ex)) {
                    return false;
                }
            }

            for (const term of terms) {
                if (term.exact) {
                    if (textLower !== term.text.toLowerCase()) {
                        return false;
                    }
                } else {
                    if (!textLower.includes(term.text.toLowerCase())) {
                        return false;
                    }
                }
            }

            return true;
        }

        const searchInJobFields = (job, searchTerm) => {
            const searchLower = searchTerm.toLowerCase();

            const fieldsToSearch = [job.Job_Profile || "", job.Job_Family_Group || "", job.Time_Type || "", job["Worker_sub-type_ENG"] || ""];

            const foundInGeneralFields = fieldsToSearch.some(field => field.toLowerCase().includes(searchLower));

            if (foundInGeneralFields) return true;

            return job.All_Job_Posting_Locations_for_Job_Requisition_group.some(item => {
                const jobCity = ((item["Location"] && item["Location"].split(",")[0].trim()) || "").toLowerCase();
                const jobState = ((item["Location_Address_-_State_Province_Region"] && item["Location_Address_-_State_Province_Region"].trim()) || "").toLowerCase();
                const jobCountry = (item["Location_Address_-_Country"] || "").toLowerCase();

                return jobCity.includes(searchLower) || jobState.includes(searchLower) || jobCountry.includes(searchLower);
            });
        };

        jobList.forEach(job => {
            if (job.Status === "Open") {
                let match = true;

                if (!noParams) {
                    // Filtro de búsqueda con múltiples términos
                    if (search && search[0]) {
                        const { terms, excludeTerms } = parseSearchQuery(search[0]);

                        const jobMatchesSearch = job => {
                            const fields = [job.Job_Posting_Title, job.Job_Requisition_ID, job.Job_Category, job.Job_Profile, job.Job_Family_Group, job.Time_Type, job["Worker_sub-type_ENG"]].filter(Boolean);

                            // Además buscar en ubicaciones
                            job.All_Job_Posting_Locations_for_Job_Requisition_group.forEach(item => {
                                if (item.Location) fields.push(item.Location);
                                if (item["Location_Address_-_State_Province_Region"]) fields.push(item["Location_Address_-_State_Province_Region"]);
                                if (item["Location_Address_-_Country"]) fields.push(item["Location_Address_-_Country"]);
                            });

                            return fields.some(field => matchesAdvancedSearch(field, terms, excludeTerms));
                        };

                        if (!jobMatchesSearch(job)) {
                            match = false;
                        }
                    }

                    // Profile filter
                    if (profile && match && !profile.some(p => job.Job_Profile.toLowerCase().includes(p.toLowerCase()))) {
                        match = false;
                    }

                    // Area filter
                    if (team && match && !team.some(a => job.Job_Family_Group.toLowerCase() === a.toLowerCase())) {
                        match = false;
                    }

                    // Position type filter
                    if (position && match && !position.some(a => job["Worker_sub-type_ENG"].toLowerCase() === a.toLowerCase())) {
                        match = false;
                    }

                    // Job type filter
                    if (type && match && !type.some(a => job.Time_Type.toLowerCase() === a.toLowerCase())) {
                        match = false;
                    }

                    // Location filters
                    if ((country || region || location) && match) {
                        const locations = job.All_Job_Posting_Locations_for_Job_Requisition_group;
                        let locationMatch = false;

                        locations.some(item => {
                            const jobCity = item["Location"].split(",")[0].trim();
                            const jobState = item["Location_Address_-_State_Province_Region"] || "";
                            const jobCountry = item["Location_Address_-_Country"] || "";

                            if (location && location.some(loc => matchesArrayFilter(jobCity, [loc]))) {
                                locationMatch = true;
                                return true;
                            }
                            if (region && region.some(reg => matchesArrayFilter(jobState, [reg]))) {
                                locationMatch = true;
                                return true;
                            }
                            if (country && country.some(ctry => matchesArrayFilter(jobCountry, [ctry]))) {
                                locationMatch = true;
                                return true;
                            }
                        });

                        if (!locationMatch) {
                            match = false;
                        }
                    }
                }

                if (match) {
                    job["Worker_sub-type_ENG"] && jobTypeSet.add(job["Worker_sub-type_ENG"]);
                    job["Time_Type"] && positionTypeSet.add(job["Time_Type"]);

                    // Poblar sets para filtros de ubicación
                    job.All_Job_Posting_Locations_for_Job_Requisition_group.forEach(item => {
                        const locationCity = item["Location"].split(",")[0].trim();
                        const region = item["Location_Address_-_State_Province_Region"] || "";
                        const country = item["Location_Address_-_Country"] || "";

                        if (country) countrySet.add(country);
                        if (region) stateSet.add([region, country]);
                        if (locationCity) citySet.add([locationCity, region, country]);
                    });

                    job.locations = job.All_Job_Posting_Locations_for_Job_Requisition_group.map(item => {
                        const locationCity = item["Location"].split(",")[0].trim();
                        return (locationsList[locationCity] && locationsList[locationCity][localization]) || locationCity;
                    }).join(" - ");

                    jobListFiltered.push(job);
                }
            }
        });

        positionTypeSet.add(translations[localization]["Full time"]);
        positionTypeSet.add(translations[localization]["Part time"]);
        jobTypeSet.add(translations[localization]["Contingent Worker"]);
        jobTypeSet.add(translations[localization]["Permanent Employee"]);
        jobTypeSet.add(translations[localization]["Temporary Employee"]);

        // Poblar filtros
        populateSelect("position", Array.from(jobTypeSet).sort());
        populateSelect("type", Array.from(positionTypeSet).sort());
        //populateLocationFilters(countrySet, stateSet, citySet);

        // Ordenar
        jobListFiltered.sort((a, b) => {
            const dateComparison = new Date(b.Start_Date) - new Date(a.Start_Date);
            if (dateComparison !== 0) {
                return dateComparison;
            }

            const aIdNum = parseInt(a.Job_Requisition_ID.replace(/\D/g, "")) || 0;
            const bIdNum = parseInt(b.Job_Requisition_ID.replace(/\D/g, "")) || 0;
            return bIdNum - aIdNum;
        });

        return jobListFiltered;
    }

    // ===== FUNCIÓN DE RENDERIZADO =====
    function renderJobs(data, page) {
        const jobList = document.getElementById("job-list");
        const resultContainer = document.querySelector("#results");

        if (page === 1) jobList.innerHTML = "";
        const start = (page - 1) * itemsPerPage;
        const paginatedJobs = data.slice(start, start + itemsPerPage);

        const loadMoreBtn = document.getElementById("load-more");
        if (loadMoreBtn) {
            loadMoreBtn.textContent = translations[localization].load_more;
        }

        if (paginatedJobs.length === 0 && page === 1) {
            if (resultContainer) {
                resultContainer.innerHTML = "<p>No jobs match the selected filters.</p>";
            }
            if (loadMoreBtn) {
                loadMoreBtn.style.display = "none";
            }
            return;
        }

        paginatedJobs.forEach(job => {
            const jobCard = document.createElement("div");
            jobCard.classList.add("job-card");
            const startDate = new Date(job.Start_Date.replace(/-/g, "/"));
            const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
            const formattedDate = startDate.toLocaleDateString(localization, options);
            var jobtype = job["Time_Type"].toLowerCase().includes("part") ? translations[localization]["Part time"] : translations[localization]["Full time"];
            var countryName = "";

            const locationList = job.All_Job_Posting_Locations_for_Job_Requisition_group.map(function(item) {
                if (!countryName) {
                    countryName = item["Location_Address_-_Country"]
                        .split(",")[0]
                        .trim()
                        .toLowerCase();
                }
                var location = item["Location"].split(",")[0].trim() || "";
                var locationName = locationsList[location] && locationsList[location][localization] ? locationsList[location][localization] : location;
                return locationName;
            }).filter(function(name) {
                return name;
            });

            var formattedLocations = "";
            if (locationList.length === 1) {
                formattedLocations = locationList[0];
            } else if (locationList.length > 1) {
                formattedLocations = locationList[0] + " +" + (locationList.length - 1) + " " + translations[localization].more;
            }

            const jobItemLink = window.location.href.split("?")[0] + "?jobItem=" + job.Job_Requisition_ID + "-" + job.Job_Category.trim() + "-" + countryName.trim() + "-" + job["Job_Posting_Title"];

            jobCard.innerHTML =
                '<div class="container-position">' +
                "<h4>" +
                (job.Job_Posting_Title || "") +
                "</h4>" +
                "<a target='_blank' href=" +
                jobItemLink.toLowerCase().replace(/\s+/g, "-") +
                (seoQueryString ? "&" : "") +
                seoQueryString +
                ' class="call-to-action" >' +
                translations[localization].view_bio +
                '<svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25504 0L9.75496 7.49928L2.2552 15L0 12.7451L5.2449 7.49952L8.31182e-05 2.25515L2.25504 0Z" fill="#57822B"/></svg></a>' +
                '<p class="position-id" >Req ID: ' +
                (job.Job_Requisition_ID || "") +
                (job.Job_Category ? "-" + job.Job_Category : "") +
                "</div>" +
                '<div class="wrapper-items">' +
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_63_5511)"><mask id="mask0_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 0H32V32H0V0Z" fill="white"></path></mask><g mask="url(#mask0_63_5511)"><mask id="mask1_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 32H32V0H0V32Z" fill="white"></path></mask><g mask="url(#mask1_63_5511)"><path d="M16.0275 15.0361C14.0998 15.0361 12.5026 13.4389 12.5026 11.5112C12.5026 9.58346 14.0998 7.98621 16.0275 7.98621C17.9553 7.98621 19.5525 9.58346 19.5525 11.5112C19.4974 13.494 17.9553 15.0361 16.0275 15.0361ZM16.0275 6.93974C13.494 6.93974 11.4561 9.03269 11.4561 11.5662C11.4561 14.0998 13.494 16.1377 16.0275 16.1377C18.5611 16.1377 20.6541 14.0998 20.6541 11.5662C20.6541 9.03269 18.5611 6.93974 16.0275 6.93974Z" fill="#0164A1"></path></g><mask id="mask2_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 32H32V0H0V32Z" fill="white"></path></mask><g mask="url(#mask2_63_5511)"><path d="M25.4458 12.0069C25.5559 17.6248 17.9552 27.1532 16.0275 29.4114C14.1549 27.1532 6.44406 17.6248 6.60929 12.0069V11.7866C6.60929 11.7315 6.60929 11.6764 6.60929 11.6213C6.60929 11.6213 6.60929 11.5663 6.60929 11.5112C6.60929 6.27882 10.8503 2.09293 15.9725 2.09293C21.0947 2.09293 25.4458 6.3339 25.4458 11.5663C25.4458 11.6213 25.4458 11.6764 25.3907 11.6764C25.3907 11.7315 25.3907 11.7866 25.3907 11.8967L25.4458 12.0069ZM26.5473 11.7866C26.5473 11.6764 26.5473 11.6213 26.5473 11.5663C26.5473 5.78312 21.8107 1.04646 16.0275 1.04646C10.2444 1.04646 5.50774 5.78312 5.50774 11.5663C5.50774 11.6213 5.50774 11.6764 5.50774 11.7315V11.7866V11.8967C5.50774 11.9518 5.50774 12.0069 5.50774 12.062C5.34251 18.7263 14.8709 29.7969 15.5869 30.6231C15.642 30.7332 15.6971 30.7332 15.8623 30.7883C15.9174 30.8434 15.9725 30.8434 16.0275 30.8434C16.1377 30.8434 16.1928 30.8434 16.2478 30.7883C16.358 30.7332 16.4131 30.6781 16.5232 30.6231C17.074 29.907 26.7676 18.7263 26.5473 12.0069C26.5473 11.8967 26.5473 11.8967 26.5473 11.8416V11.7866Z" fill="#0164A1"></path></g></g></g><defs><clipPath id="clip0_63_5511"><rect width="32" height="32" fill="white"></rect></clipPath></defs></svg>' +
                '<div class="text-container-items" >' +
                '<p class="job-title-item" >' +
                translations[localization].loc +
                "</p>" +
                '<p class="job-content-item">' +
                (formattedLocations || "") +
                "</p>" +
                "</div>" +
                "</div>" +
                '<div class="wrapper-items">' +
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<g clip-path="url(#clip0_63_5531)"><mask id="mask0_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00323486 0H32.0032V32H0.00323486V0Z" fill="white"/></mask><g mask="url(#mask0_63_5531)"><mask id="mask1_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask><g mask="url(#mask1_63_5531)"><path d="M10.7978 17.7347C10.5775 17.7347 10.4123 17.8449 10.3572 18.0101C10.192 18.1203 9.8615 18.1203 9.36581 18.1203C8.81503 18.1203 8.48457 18.0652 8.31934 18.0101C8.20918 17.9 8.04395 17.7347 7.87872 17.7347C7.60333 17.7347 7.32794 18.0101 7.32794 18.3406C7.32794 19.1117 8.59472 19.2769 9.36581 19.2769C10.1369 19.2769 11.3486 19.1668 11.3486 18.3406C11.3486 17.9551 11.1283 17.7347 10.7978 17.7347Z" fill="#0164A1"/></g>' +
                '<mask id="mask2_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask>' +
                '<g mask="url(#mask2_63_5531)"><path d="M6.28234 14.6508C5.95188 14.6508 5.73157 14.9262 5.73157 15.2016C5.73157 15.4769 5.95188 15.7523 6.28234 15.7523C6.55773 15.7523 6.83312 15.4769 6.83312 15.2016C6.83312 14.9262 6.55773 14.6508 6.28234 14.6508Z" fill="#0164A1"/></g>' +
                '<mask id="mask3_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask>' +
                '<g mask="url(#mask3_63_5531)"><path d="M12.5616 14.6508C12.2863 14.6508 12.0109 14.9262 12.0109 15.2016C12.0109 15.4769 12.2863 15.7523 12.5616 15.7523C12.837 15.7523 13.1124 15.4769 13.1124 15.2016C13.1124 14.9262 12.837 14.6508 12.5616 14.6508Z" fill="#0164A1"/></g>' +
                '<mask id="mask4_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask>' +
                '<g mask="url(#mask4_63_5531)">' +
                '<path d="M29.7451 29.4666H19.4456V17.9554H21.5936C21.869 19.0019 22.7503 20.0483 23.6315 20.0483H24.6229C24.8432 20.0483 25.1737 20.0483 25.6143 20.0483C26.4404 20.0483 27.3217 19.0019 27.6521 17.9554H29.7451V29.4666ZM23.4112 16.248H25.7795C26.2201 16.248 26.6608 16.4132 26.6608 17.1292C26.6608 18.0105 25.8897 18.9468 25.6143 18.9468C25.0084 18.9468 24.678 18.9468 24.6229 18.9468H23.6315C23.3561 18.8917 22.5299 18.0105 22.5299 17.1292C22.5299 16.4132 23.0256 16.248 23.4112 16.248ZM11.7898 20.4339C11.2391 20.7093 10.3028 20.8194 9.97229 20.8194H8.59535C8.31996 20.8194 7.38365 20.7093 6.77779 20.4339C6.2821 20.2136 4.85008 18.6163 4.62977 18.3409C4.5747 18.2859 4.51962 18.2308 4.46454 18.1206C4.18915 17.8452 3.52823 17.1292 3.47315 16.4683C3.47315 16.248 3.41807 15.7523 3.36299 15.2015V12.3926C3.96884 13.0535 4.5747 13.6593 5.23563 13.6593H13.2219C13.9379 13.6593 14.5437 13.0535 15.1496' +
                " 12.3926V15.1464C15.0394 16.0277 15.0394 16.3581 15.0394 16.4683C14.9293 17.0741 14.3234 17.7902 14.048 18.1206C13.9929 18.2308 13.9379 18.2859 13.8828 18.3409C13.7176 18.6714 12.2855 20.2136 11.7898 20.4339ZM2.92237 9.25315C2.92237 7.49067 3.5833 5.89343 4.73993 4.68172V9.69377H2.92237V9.25315ZM8.65043 2.36847H10.0824C10.1375 2.36847 10.1926 2.42355 10.1926 2.47862V9.69377H8.54027V2.47862C8.54027 2.42355 8.54027 2.36847 8.65043 2.36847ZM15.7554 9.25315V9.69377H13.8828V4.7368C15.0394 5.89343 15.7554 7.49067 15.7554 9.25315ZM11.2941 3.08448C11.8449 3.30479 12.3406 3.5251 12.8363 3.85556V9.74885H11.2941V3.08448ZM15.0945 10.8504C14.9843 10.9606 14.8742 11.1258 14.764 11.2359C14.3785 11.6766 13.6625 12.6129 13.2769 12.6129H5.34578C5.01532 12.6129 4.24423 11.6766 3.85869 11.2359C3.74853 11.1258 3.63838 10.9606 3.52823 10.8504H15.0945ZM7.43872 9.69377H5.89656V3.85556C6.33717 3.5251 6.83287" +
                ' 3.30479 7.43872 3.08448V9.69377ZM30.3509 16.8538H27.7623C27.6521 15.6972 26.7158 15.2015 25.7795 15.2015H23.4112C22.4749 15.2015 21.5936 15.6972 21.4284 16.8538H18.8398C18.5644 16.8538 18.289 17.1292 18.289 17.4046V20.8745C17.2425 20.0483 15.6453 19.4976 14.6539 19.2222C14.764 19.112 14.8191 19.0569 14.8191 19.0569C14.8191 19.0019 14.8742 18.9468 14.9293 18.9468C15.3148 18.5062 16.0308 17.68 16.196 16.7437C16.2511 16.4683 16.3062 16.0277 16.3062 15.2566V11.1809C16.3613 11.0707 16.3613 10.9606 16.3613 10.9055H16.857C17.1874 10.9055 17.4628 10.6301 17.4628 10.2996C17.4628 10.0242 17.1874 9.74885 16.857 9.74885V9.30823C16.857 6.88482 15.7554 4.68172 13.8828 3.30479V3.19463C13.8828 2.91924 13.6074 2.64386 13.332 2.64386C13.2219 2.64386 13.1117 2.69893 13.0566 2.75401C12.4508 2.36847 11.7898 2.14816 11.0738 1.98293C10.8535 1.59738 10.468 1.37708 10.0274 1.37708H8.59535C8.15473 1.37708 7.71411 1.65246 7.4938 1.98293C6.77779 2.14816 6.17194 2.42355 5.51101 2.75401C5.51101 2.64386 5.40086 2.64386 5.2907 2.64386C5.01532 2.64386 4.73993 2.91924 4.73993 3.19463V3.30479C2.92237 4.68172 1.76575 6.88482 1.76575 9.30823V9.74885C1.43528 9.74885 1.15989 10.0242 1.15989 10.2996C1.15989 10.6301 1.43528 10.9055 1.76575 10.9055H2.31652C2.31652 11.0156 2.31652 11.0707 2.3716 11.1809V15.3117C2.42668 15.9726 2.48175 16.4683 2.48175 16.7437C2.59191 17.68 3.36299 18.5612 3.74854 18.9468C3.80361 19.0019 3.85869 19.0569 3.85869 19.0569C3.85869 19.0569 3.91377 19.1671 3.96884 19.2222C3.30792 19.3874 2.31652 19.7179 1.49036 20.1585C1.21497 20.2686 1.04974 20.5991 1.21497 20.9296C1.32513 21.0948 1.49036 21.205 1.71067 21.205C1.82082 21.205 1.82082 21.205 1.93098 21.1499C3.03253 20.5991 4.24423 20.2686 4.79501 20.1585C5.34578 20.7643 5.95163 21.3151 6.39225 21.4803C7.16334 21.8659 8.26489 21.921 8.65043 21.921H10.0274C10.4129 21.921 11.5145 21.8108 12.2855 21.4803C12.7262 21.3151 13.3871 20.7093 13.8828 20.2136C15.5351 20.5991 18.3441 21.5905 18.3441 22.8022V30.1275C18.3441 30.4029 18.6194 30.6783 18.8948 30.6783H30.3509C30.6263 30.6783 30.9017 30.4029 30.9017 30.1275V17.4046C30.9017 17.0741 30.6263 16.8538 30.3509 16.8538Z" fill="#0164A1"/>' +
                '<mask id="mask5_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask><g mask="url(#mask5_63_5531)"><path d="M27.5965 21.3701H21.4829C21.1525 21.3701 20.8771 21.6455 20.8771 21.9209C20.8771 22.2514 21.1525 22.5267 21.4829 22.5267H27.5965C27.927 22.5267 28.2024 22.2514 28.2024 21.9209C28.2024 21.6455 27.927 21.3701 27.5965 21.3701Z" fill="#0164A1"/></g><mask id="mask6_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask><g mask="url(#mask6_63_5531)"><path d="M27.5965 24.0139H21.4829C21.1525 24.0139 20.8771 24.2343 20.8771 24.5647C20.8771 24.8401 21.1525 25.1155 21.4829 25.1155H27.5965C27.927 25.1155 28.2024 24.8401 28.2024 24.5647C28.2024 24.2343 27.927 24.0139 27.5965 24.0139Z" fill="#0164A1"/></g><mask id="mask7_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask><g mask="url(#mask7_63_5531)"><path d="M25.0079 26.6021H21.4829C21.1525 26.6021 20.8771 26.8775 20.8771 27.1529C20.8771 27.4833 21.1525 27.7587 21.4829 27.7587H25.0079C25.3383 27.7587 25.6137 27.4833 25.6137 27.1529C25.5587 26.8775 25.3383 26.6021 25.0079 26.6021Z" fill="#0164A1"/></g><mask id="mask8_63_5531" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="32"><path d="M0.00366211 32H32.0037V0H0.00366211V32Z" fill="white"/></mask><g mask="url(#mask8_63_5531)"><path d="M27.2117 26.5475C26.8813 26.5475 26.6059 26.8229 26.6059 27.1533C26.6059 27.4838 26.8813 27.7592 27.2117 27.7592C27.5973 27.7592 27.8176 27.4838 27.8176 27.1533C27.8176 26.8229 27.5973 26.5475 27.2117 26.5475Z" fill="#0164A1"/></g></g></g><defs><clipPath id="clip0_63_5531"><rect width="32" height="32" fill="white"/></clipPath></defs></svg>' +
                '<div class="text-container-items">' +
                '<p class="job-title-item">' +
                translations[localization].category +
                "</p> " +
                '<p class="job-content-item"> ' +
                ((jobAreasList[job.Job_Family_Group] && jobAreasList[job.Job_Family_Group][localization]) || "") +
                "</p>" +
                "</div>" +
                "</div>" +
                '<div class="wrapper-items">' +
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_63_5574)"><mask id="mask0_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00549316 0H31.9945V32H-0.00549316V0Z" fill="white"></path></mask><g mask="url(#mask0_63_5574)"><mask id="mask1_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask1_63_5574)"><path d="M8.04835 26.5931H5.23455V23.7794H8.04835V26.5931ZM8.60007 22.6759H4.68283C4.40697 22.6759 4.1311 22.9518 4.1311 23.2828V27.2C4.1311 27.4759 4.40697 27.7518 4.68283 27.7518H8.60007C8.87593 27.7518 9.15179 27.4759 9.15179 27.2V23.2828C9.15179 22.9518 8.9311 22.6759 8.60007 22.6759Z" fill="#0164A1"></path></g><mask id="mask2_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask2_63_5574)"><path d="M14.283 26.5931H11.4692V23.7794H14.283V26.5931ZM14.8347 22.6759H10.9726C10.6416 22.6759 10.3657 22.9518 10.3657 23.2828V27.2C10.3657 27.4759 10.6416 27.7518 10.9726 27.7518H14.8347C15.1657 27.7518 15.4416 27.4759 15.4416 27.2V23.2828C15.4416 22.9518 15.1657 22.6759 14.8347 22.6759Z" fill="#0164A1"></path></g><mask id="mask3_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask3_63_5574)"><path d="M20.5165 26.5931H17.7027V23.7794H20.5165V26.5931ZM21.0682 22.6759H17.151C16.8751 22.6759 16.5992 22.9518 16.5992 23.2828V27.2C16.5992 27.4759 16.8751 27.7518 17.151 27.7518H21.0682C21.3441 27.7518 21.6199 27.4759 21.6199 27.2V23.2828C21.6199 22.9518 21.3992 22.6759 21.0682 22.6759Z" fill="#0164A1"></path></g><mask id="mask4_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z"' +
                ' fill="white"></path></mask><g mask="url(#mask4_63_5574)"><path d="M8.04835 20.4693H5.23455V17.6555H8.04835V20.4693ZM8.60007 16.6072H4.68283C4.40697 16.6072 4.1311 16.8831 4.1311 17.159V21.0762C4.1311 21.3521 4.40697 21.6279 4.68283 21.6279H8.60007C8.87593 21.6279 9.15179 21.3521 9.15179 21.0762V17.159C9.15179 16.8279 8.9311 16.6072 8.60007 16.6072Z" fill="#0164A1"></path></g><mask id="mask5_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask5_63_5574)"><path d="M14.283 20.4693H11.4692V17.6555H14.283V20.4693ZM14.8347 16.6072H10.9726C10.6416 16.6072 10.3657 16.8831 10.3657 17.159V21.0762C10.3657 21.3521 10.6416 21.6279 10.9726 21.6279H14.8347C15.1657 21.6279 15.4416 21.3521 15.4416 21.0762V17.159C15.4416 16.8279 15.1657 16.6072 14.8347 16.6072Z" fill="#0164A1"></path></g><mask id="mask6_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask6_63_5574)"><path d="M20.5165 20.4693H17.7027V17.6555H20.5165V20.4693ZM21.0682 16.6072H17.151C16.8751 16.6072 16.5992 16.8831 16.5992 17.159V21.0762C16.5992 21.3521 16.8751 21.6279 17.151 21.6279H21.0682C21.3441 21.6279 21.6199 21.3521 21.6199 21.0762V17.159C21.6199 16.8279 21.3992 16.6072 21.0682 16.6072Z" fill="#0164A1"></path></g><mask id="mask7_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask7_63_5574)"><path d="M26.7513 20.4693H23.9375V17.6555H26.7513V20.4693ZM27.303 16.6072H23.4409C23.1099 16.6072 22.834 16.8831 22.834 17.159V21.0762C22.834 21.3521 23.1099 21.6279 23.4409 21.6279H27.303C27.634 21.6279 27.9099 21.3521 27.9099 21.0762V17.159C27.9099 16.8279 27.634 16.6072 27.303 16.6072Z" fill="#0164A1"></path></g><mask id="mask8_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32">' +
                '<path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask8_63_5574)"><path d="M14.283 14.4001H11.4692V11.5863H14.283V14.4001ZM14.8347 10.4828H10.9726C10.6416 10.4828 10.3657 10.7587 10.3657 11.0346V14.9518C10.3657 15.2277 10.6416 15.5035 10.9726 15.5035H14.8347C15.1657 15.5035 15.4416 15.2277 15.4416 14.9518V11.0346C15.4416 10.7035 15.1657 10.4828 14.8347 10.4828Z" fill="#0164A1"></path></g><mask id="mask9_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask9_63_5574)"><path d="M20.5165 14.4001H17.7027V11.5863H20.5165V14.4001ZM21.0682 10.4828H17.151C16.8751 10.4828 16.5992 10.7587 16.5992 11.0346V14.9518C16.5992 15.2277 16.8751 15.5035 17.151 15.5035H21.0682C21.3441 15.5035 21.6199 15.2277 21.6199 14.9518V11.0346C21.6199 10.7035 21.3992 10.4828 21.0682 10.4828Z" fill="#0164A1"></path></g><mask id="mask10_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask10_63_5574)"><path d="M26.7513 14.4001H23.9375V11.5863H26.7513V14.4001ZM27.303 10.4828H23.4409C23.1099 10.4828 22.834 10.7587 22.834 11.0346V14.9518C22.834 15.2277 23.1099 15.5035 23.4409 15.5035H27.303C27.634 15.5035 27.9099 15.2277 27.9099 14.9518V11.0346C27.9099 10.7035 27.634 10.4828 27.303 10.4828Z" fill="#0164A1"></path></g><mask id="mask11_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask11_63_5574)"><path d="M28.3512 29.1867H3.68908C3.19253 29.1867 2.75115 28.7453 2.75115 28.2487V8.44184H29.2891V28.2487C29.2891 28.7453 28.8477 29.1867 28.3512 29.1867ZM3.68908 2.64874H28.3512C28.8477 2.64874 29.2891 3.09012 29.2891 3.58667V7.39356H2.75115V3.58667C2.75115 3.09012 3.13736 2.64874 3.68908 2.64874ZM28.3512 1.54529H3.68908C2.53046 1.54529 1.64771 2.48322 1.64771 3.58667V28.2487C1.64771 ' +
                '29.3522 2.53046 30.2349 3.63391 30.2349H28.296C29.3994 30.2349 30.3374 29.3522 30.3374 28.2487V3.58667C30.3925 2.48322 29.4546 1.54529 28.3512 1.54529Z" fill="#0164A1"></path></g><mask id="mask12_63_5574" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00799561 32H31.992V0H-0.00799561V32Z" fill="white"></path></mask><g mask="url(#mask12_63_5574)"><path d="M10.5308 5.57281H21.0687C21.3446 5.57281 21.6204 5.29694 21.6204 5.02108C21.6204 4.69005 21.3446 4.41418 21.0687 4.41418H10.5308C10.2549 4.41418 9.97906 4.69005 9.97906 5.02108C9.97906 5.35212 10.2549 5.57281 10.5308 5.57281Z" fill="#0164A1"></path></g></g></g><defs><clipPath id="clip0_63_5574"><rect width="32" height="32" fill="white"></rect></clipPath></defs></svg>' +
                '<div class="text-container-items"> ' +
                '<p class="job-title-item">' +
                translations[localization].posted +
                "</p> " +
                '<p class="job-content-item">' +
                (formattedDate || "") +
                "</p>" +
                "</div>" +
                "</div>" +
                '<div class="wrapper-items">' +
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_63_5633)"><mask id="mask0_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M-6.10352e-05 0H31.9999V32H-6.10352e-05V0Z" fill="white"></path></mask><g mask="url(#mask0_63_5633)"><mask id="mask1_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask1_63_5633)"><path d="M16.0272 29.6309C8.48161 29.6309 2.31294 23.4622 2.31294 15.9166C2.31294 8.31592 8.48161 2.20232 16.0272 2.20232C23.6279 2.20232 29.7415 8.31592 29.7415 15.9166C29.7415 23.4622 23.6279 29.6309 16.0272 29.6309ZM16.0272 1.10077C7.87576 1.10077 1.15631 7.76514 1.15631 15.9717C1.15631 24.1782 7.82068 30.8426 16.0272 30.8426C24.2338 30.8426 30.8981 24.1782 30.8981 15.9717C30.8981 7.76514 24.1787 1.10077 16.0272 1.10077Z" fill="#0164A1"></path></g><mask id="mask2_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask2_63_5633)"><path d="M16.027 7.3259C16.3574 7.3259 16.6328 7.05051 16.6328 6.77512V4.40679C16.6328 4.13141 16.3574 3.85602 16.027 3.85602C15.7516 3.85602 15.4762 4.13141 15.4762 4.40679V6.72005C15.4762 7.05051 15.7516 7.3259 16.027 7.3259Z" fill="#0164A1"></path></g><mask id="mask3_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask3_63_5633)"><path d="M16.027 24.3994C15.7516 24.3994 15.4762 24.6748 15.4762 24.9502V27.2635C15.4762 27.5389 15.7516 27.8142 16.027 27.8142C16.3574 27.8142 16.6328 27.5389 16.6328 27.2635V24.9502C16.5777 24.6748 16.3574 24.3994 16.027 24.3994Z" fill="#0164A1"></path></g><mask id="mask4_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32">' +
                '<path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask4_63_5633)"><path d="M27.4293 15.3115H25.1161C24.8407 15.3115 24.5653 15.5869 24.5653 15.8623C24.5653 16.1377 24.8407 16.413 25.1161 16.413H27.4293C27.7598 16.413 28.0352 16.1377 28.0352 15.8623C28.0352 15.5869 27.7598 15.3115 27.4293 15.3115Z" fill="#0164A1"></path></g><mask id="mask5_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask5_63_5633)"><path d="M6.93992 15.3115H4.57159C4.2962 15.3115 4.02081 15.5869 4.02081 15.8623C4.02081 16.1377 4.2962 16.413 4.57159 16.413H6.88484C7.16023 16.413 7.43561 16.1377 7.43561 15.8623C7.43561 15.5869 7.2153 15.3115 6.93992 15.3115Z" fill="#0164A1"></path></g><mask id="mask6_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask6_63_5633)"><path d="M10.4107 6.11433C10.1353 6.27957 10.0252 6.61003 10.1904 6.88542C10.3557 7.16081 10.6861 7.27096 10.9615 7.10573C11.2369 6.9405 11.3471 6.61003 11.1818 6.33464C11.0166 6.00418 10.631 5.9491 10.4107 6.11433Z" fill="#0164A1"></path></g><mask id="mask7_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask7_63_5633)"><path d="M20.9292 24.3445C20.6538 24.4547 20.5437 24.8402 20.7089 25.1156C20.8742 25.391 21.2046 25.5011 21.48 25.3359C21.7554 25.1707 21.8655 24.8402 21.7003 24.5648C21.5351 24.2894 21.2046 24.1793 20.9292 24.3445Z" fill="#0164A1"></path></g><mask id="mask8_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask8_63_5633)"><path d="M25.3899 10.9058C25.6653 10.7405 25.7203 10.4101 25.6102 10.1347C25.445 9.85929 25.1145 9.80421 ' +
                '24.8391 9.91437C24.5637 10.0796 24.5086 10.4101 24.6739 10.6855C24.729 10.9608 25.0594 11.071 25.3899 10.9058Z" fill="#0164A1"></path></g><mask id="mask9_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask9_63_5633)"><path d="M6.55368 20.4885C6.27829 20.6537 6.16814 20.9842 6.33337 21.2596C6.44353 21.535 6.82907 21.6451 7.10446 21.4799C7.37984 21.3697 7.49 20.9842 7.32477 20.7088C7.15953 20.4334 6.77399 20.3233 6.55368 20.4885Z" fill="#0164A1"></path></g><mask id="mask10_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask10_63_5633)"><path d="M6.38904 10.8503C6.66442 11.0156 6.99489 10.9054 7.16012 10.63C7.32535 10.3546 7.27027 10.0242 6.99489 9.85893C6.7195 9.6937 6.38903 9.74878 6.2238 10.0792C6.05857 10.3546 6.11365 10.6851 6.38904 10.8503Z" fill="#0164A1"></path></g><mask id="mask11_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask11_63_5633)"><path d="M25.2246 20.4336C24.9492 20.2684 24.6188 20.3235 24.4535 20.5988C24.2883 20.8742 24.3985 21.2047 24.6739 21.3699C24.9492 21.4801 25.2797 21.425 25.4449 21.1496C25.5551 20.8742 25.5 20.5438 25.2246 20.4336Z" fill="#0164A1"></path></g><mask id="mask12_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask12_63_5633)"><path d="M20.7645 6.94001C21.0399 7.10524 21.3704 7.05016 21.5356 6.77477C21.6457 6.49939 21.5907 6.16892 21.3153 6.00369C21.0399 5.83846 20.7094 5.94861 20.5442 6.224C20.434 6.49939 20.5442 6.82985 20.7645 6.94001Z" fill="#0164A1"></path></g>' +
                '<mask id="mask13_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask13_63_5633)"><path d="M10.7948 24.2899C10.5194 24.1247 10.1889 24.2348 10.0237 24.5102C9.85847 24.7856 9.91354 25.1161 10.244 25.2813C10.5194 25.4465 10.8499 25.3915 11.0151 25.061C11.1803 24.7856 11.0702 24.4551 10.7948 24.2899Z" fill="#0164A1"></path></g><mask id="mask14_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask14_63_5633)"><path d="M16.0284 16.8531C15.5327 16.8531 15.0921 16.4125 15.0921 15.9168C15.0921 15.4211 15.5327 14.9805 16.0284 14.9805C16.5241 14.9805 16.9647 15.4211 16.9647 15.9168C16.9647 16.4125 16.5241 16.8531 16.0284 16.8531ZM21.5361 9.63796L17.0198 14.1543C16.9096 14.0442 16.7444 14.0442 16.5791 13.9891V11.5657C16.5791 11.2352 16.3038 10.9598 15.9733 10.9598C15.6979 10.9598 15.4225 11.2352 15.4225 11.5657V13.9891C14.5413 14.2645 13.9354 15.0355 13.9354 15.9719C13.9354 17.0734 14.8717 18.0097 15.9733 18.0097C17.0748 18.0097 18.0112 17.0734 18.0112 15.9719C18.0112 15.5863 17.901 15.2559 17.7358 14.9805L22.2521 10.4641C22.4724 10.1887 22.4724 9.85827 22.2521 9.69303C22.0869 9.41765 21.7564 9.41765 21.5361 9.63796Z" fill="#0164A1"></path></g></g></g><defs><clipPath id="clip0_63_5633"><rect width="32" height="32" fill="white"></rect></clipPath></defs></svg>' +
                '<div class="text-container-items">' +
                '<p class="job-title-item">' +
                translations[localization].type +
                "</p> " +
                '<p class="job-content-item">' +
                (jobtype || "") +
                "</p>" +
                "</div>" +
                "</div>";

            jobList.appendChild(jobCard);
        });

        if (loadMoreBtn) {
            loadMoreBtn.style.display = paginatedJobs.length < itemsPerPage ? "none" : "block";
        }
    }

    function loadMoreJobs() {
        currentPage++;
        renderJobs(window.jobData, currentPage);
    }

    function getFormSnapshot(form) {
        const formData = new FormData(form);
        const values = {};

        for (const [key, value] of formData.entries()) {
            if (!values[key]) {
                values[key] = [];
            }
            values[key].push(value);
        }

        // Ordenar claves y valores para garantizar comparación estable
        const sorted = {};
        Object.keys(values)
            .sort()
            .forEach(key => {
                sorted[key] = values[key].slice().sort();
            });

        return JSON.stringify(sorted);
    }

    function areSnapshotsEqual(snapshotA, snapshotB) {
        return snapshotA === snapshotB;
    }

    // ===== FUNCIONES DE EVENTOS =====
    function handleSubmit(event) {
        event.preventDefault();

        const params = [];

        // Input de búsqueda
        const searchInput = document.getElementById("search");
        if (searchInput && searchInput.value.trim()) {
            params.push(`search=${encodeURIComponent(searchInput.value.trim())}`);
        }

        // Selects múltiples
        const multiSelects = ["team", "country", "region", "location", "position", "type"];
        multiSelects.forEach(selectId => {
            const selectedValues = $(`#${selectId}`).val();
            if (selectedValues && selectedValues.length > 0) {
                selectedValues.forEach(value => {
                    if (value.trim()) {
                        params.push(`${selectId}=${encodeURIComponent(value)}`);
                    }
                });
            }
        });

        let queryString = params.length > 0 ? "?" + params.join("&") : "";
        console.log("seo:", seoQueryString);
        // Add seoQueryString if exists
        if (seoQueryString && seoQueryString.length > 0) {
            // Si ya hay parámetros en queryString, agregamos con "&"
            queryString += (queryString ? "&" : "?") + seoQueryString;
        }
        window.location.href = window.location.pathname + queryString;
    }

    function setFilterValues() {
        const params = getParams();

        // Input de búsqueda
        if (params.search && params.search[0]) {
            const searchElement = document.getElementById("search");
            if (searchElement) {
                searchElement.value = params.search[0];
            }
        }

        // Selects múltiples
        const multiSelects = ["team", "country", "region", "location", "position", "type"];
        multiSelects.forEach(selectId => {
            if (params[selectId]) {
                try {
                    $(`#${selectId}`)
                        .val(params[selectId])
                        .trigger("change");
                } catch (error) {
                    // Error setting values
                }
            }
        });
    }

    // ===== INICIALIZACIÓN PRINCIPAL =====
    async function initializeJobsModule() {
        try {
            // 1. Inicializar traducciones y variables
            initializeTranslations();

            // 2. Configurar jobsUrl
            const baseUrl = window.location.origin + (window.location.hostname.includes("localhost") ? "/local" : "");

            // Obtener jcrPath del elemento o configuración
            const jcrPathElement = document.querySelector("[data-jcr-path]");
            const jcrPath = (jcrPathElement && jcrPathElement.dataset.jcrPath) || window.jcrPath || "";
            jobsUrl = `${baseUrl}/dam/jcr:${jcrPath}`;

            // 3. Cargar categorías
            statesList = await getCategories("state");
            locationsList = await getCategories("location");
            jobAreasList = await getCategories("job_area");

            // Hacer disponibles globalmente
            window.statesList = statesList;
            window.locationsList = locationsList;
            window.jobAreasList = jobAreasList;

            // 4. Configurar UI
            setTitlesByLocalization();
            await populateAreaSelect(jobAreasList);

            // 5. Inicializar Select2
            setTimeout(() => {
                initializeMultiSelects();
            }, 200);

            // 6. Configurar evento de formulario
            let lastSnapshot = null;

            const form = document.getElementById("filter-form");
            if (form) {
                form.addEventListener("submit", handleSubmit);

                // Inicializar snapshot del estado actual del formulario
                lastSnapshot = getFormSnapshot(form);

                // Escuchar Enter en toda la página
                document.addEventListener("keydown", event => {
                    // Verificamos que sea Enter y que no sea un textarea ni select2 abierto
                    const isEnter = event.key === "Enter";
                    const isTextArea = event.target.tagName === "TEXTAREA";
                    const isSelect2Search = event.target.classList.contains("select2-search__field");

                    if (isEnter && !isTextArea && !isSelect2Search) {
                        event.preventDefault();
                        const newSnapshot = getFormSnapshot(form);
                        if (!areSnapshotsEqual(newSnapshot, lastSnapshot)) {
                            lastSnapshot = newSnapshot;
                            handleSubmit(new Event("submit"));
                        }
                    }
                });
            }

            // Hacer loadMoreJobs disponible globalmente
            window.loadMoreJobs = loadMoreJobs;

            // 7. Cargar y renderizar trabajos
            if (jobsUrl && jcrPath) {
                const response = await fetch(jobsUrl);
                if (response.ok) {
                    const data = await response.json();
                    const jobsData = await filterJobList(data.Report_Entry || []);
                    window.jobData = jobsData;

                    setTimeout(() => {
                        setFilterValues();
                    }, 300);

                    renderJobs(jobsData, currentPage);

                    // Mostrar resultados
                    const loader = document.querySelector(".lds-ellipsis");
                    const jobsContainer = document.querySelector("#job-list");
                    const resultContainer = document.querySelector("#results");

                    if (loader) loader.style.opacity = "0";
                    if (resultContainer) resultContainer.style.opacity = "1";
                    if (jobsContainer) jobsContainer.style.opacity = "1";

                    if (jobsData.length > 0) {
                        const resultsElement = document.querySelector("#results");
                        if (resultsElement) {
                            resultsElement.innerText = jobsData.length + " " + translations[localization].results;
                        }
                    }
                }
            }
        } catch (error) {
            console.error("Error initializing jobs module:", error);
        }
    }

    initializeJobsModule();
}

export default { init };
